/** 我的提交（申请人的列表和表单）及各版本的下载（计划 F3）。 */
export default {
  mySubmissions: {
    title: '我的提交',
    subtitle: '您的规划提交、其检查结果及相关决定。',
    empty: '您还没有任何提交。请从「新建提交」开始。',
    back: '返回我的提交',
    formIntro: '此提交以您的名义、使用您的账户信息提出。',
    applicantHint: '您的姓名和电子邮件取自您的账户。如适用，请填写您的公司和专业注册号。',
  },
  downloads: {
    title: '下载',
    revision: '版本 {{revision}} 的文件',
    none: '此版本尚无文件。',
    derivedHint: 'GeoPackage 和 Shapefile 仅在该版本检查通过后生成。',
    cad_drawing: '原始图纸',
    derived_gpkg: 'GeoPackage 文件（.gpkg）',
    derived_shp: 'Shapefile 文件（.zip）',
    download: '下载',
    downloadLabel: '下载 {{name}}',
  },
} as const
